import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";
import { quotations } from "./quotations";
import { items, accounts, taxTemplates } from "../../accounting/schemas/public";

// ============================================================================
// quotation_items — รายการในใบเสนอราคา
// ============================================================================
export const quotationItems = sqliteTable("sales_quotation_items", {
  id: text("id").primaryKey(), // ULID
  quotationId: text("quotation_id").notNull().references(() => quotations.id), // FK -> quotations
  itemId: text("item_id").references(() => items.id), // FK -> items (nullable for manual entry)
  description: text("description"),
  qty: real("qty").notNull().default(1),
  rate: real("rate").notNull().default(0),
  amount: real("amount").notNull().default(0),
  accountId: text("account_id").references(() => accounts.id), // FK -> accounts (override item default)
  taxTemplateId: text("tax_template_id").references(() => taxTemplates.id), // FK -> tax_templates
  taxAmount: real("tax_amount").notNull().default(0),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
}, (table) => ({
  quotationIdx: index("qi_quotation_idx").on(table.quotationId),
}));

// Type exports
export type QuotationItem = typeof quotationItems.$inferSelect;
export type NewQuotationItem = typeof quotationItems.$inferInsert;
